import { createMutation } from "@/mutations";
import { login } from "@/features/auth/api/session";
import type { AuthCredentials, TokensResponse } from "@/features/auth/api/session";
import type { AxiosResponse } from "axios";

type LoginResponse = Awaited<ReturnType<typeof login>> extends AxiosResponse<infer T>
  ? T
  : never;

export const useLoginMutation = () => {
  return createMutation<LoginResponse, AuthCredentials>({
    mutationFn: async (credentials) => {
      const response = await login(credentials);
      return response.data;
    },
    invalidateQueries: (key) => Array.isArray(key) && key[0] === "userInfo",
  });
};

